<template>
    <div>
        <b-row>
            <b-col> {{ itemIndex }} - {{ item.name }} </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-text-input
                    placeholder="Referencia"
                    v-model="tool.reference"
                    @change="update"
                ></app-form-text-input>
            </b-col>
        </b-row>
        <b-form-row>
            <b-col v-for="status in statuses" :key="status.id">
                <b-btn
                    squared
                    block
                    :variant="tool.status.id === status.id ? status.variant : 'secondary'"
                    @click="setAnswer(status)"
                    >{{ status.name }}</b-btn
                >
            </b-col>
        </b-form-row>
        <b-row v-if="requireNotes">
            <b-col>
                <app-form-textarea-input
                    label="Justificación"
                    :autofocus="true"
                    rows="2"
                    v-model="tool.notes"
                    @change="update"
                ></app-form-textarea-input>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        statuses: {
            type: Array,
            default: () => []
        },
        itemIndex: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        tool: {
            status: "",
            reference: "",
            notes: ""
        }
    }),
    computed: {
        requireNotes() {
            if (!this.tool.status) return false;

            return this.tool.status.require_notes;
        }
    },
    methods: {
        setAnswer(val) {
            this.tool.status = val;
            this.update();
        },
        update() {
            this.$emit("change", {
                tool: this.item.id,
                status: this.tool.status,
                reference: this.tool.reference,
                notes: this.tool.notes
            });
        }
    }
};
</script>